import React, { useEffect, useState } from 'react'
import { useApiContract, useMoralis, useMoralisWeb3Api, useNativeBalance, useWeb3Contract } from 'react-moralis';
import {NFTContext, useModal} from "./ModalContext";
import testContractABI from "../controllers/ropsten-abit.json";
import contractABI from "../controllers/abi.json";
import { useLayoutEffect } from 'react';
import y5Abi from "../controllers/abiY5.json"

const y5Options = {
  address: process.env.REACT_APP_Y5_ADDRESS,
  abi: y5Abi,
  chain: "bsc",
}
const options = {
  address: process.env.REACT_APP_CONTRACT_ADDRESS,
  abi: contractABI,
  chain: process.env.REACT_APP_CHAIN_ID,
}

const NFTContextProvider = ({children}) => {

  const [count, setCount] = useState(0);
  const {enableWeb3, isWeb3EnableLoading, isWeb3Enabled, Moralis, isAuthenticated,web3, user, account} = useMoralis();
  const Web3Api = useMoralisWeb3Api();
  const {data:totalMint, runContractFunction:getTotalMint, isLoading:totalMintLoading} = useApiContract({...options, functionName: 'totalSupply'});
  const {data:maxElements, runContractFunction:getMaxElements, isLoading:maxELmLoading} = useApiContract({...options, functionName: 'MAX_ELEMENTS'});
  const {data:maxReserved, runContractFunction:getMaxReserved, isLoading:maxResLoading} = useApiContract({...options, functionName: 'MAX_RESERVE_COUNT'});
  const {data:maxPublic, runContractFunction:getMaxPublic, isLoading:maxPublicLoading} = useApiContract({...options, functionName: 'MAX_BY_MINT'});
  const {data:maxPrivate, runContractFunction:getMaxPrivate, isLoading:maxPrivateLoading} = useApiContract({...options, functionName: 'MAX_BY_MINT_WHITELIST'});
  const {data:salePrice, runContractFunction:getSalePrice, isLoading:salePLoading} = useApiContract({...options, functionName: 'PRICE'});
  const {data:presalePrice, runContractFunction:getPresalePrice, isLoading:presalePLoading} = useApiContract({...options, functionName: 'PRESALE_PRICE'});
  const {data:saleStart, runContractFunction:getSaleStart, isLoading:saleStartLoading} = useApiContract({...options, functionName: 'SALE_START'});
  const {data:presaleStart, runContractFunction:getPresaleStart, isLoading:presaleStartLoading} = useApiContract({...options, functionName: 'PRESALE_START'});
  const {data:isPresaleOpen, runContractFunction:getIsPresaleOpen, isLoading:isPresaleOpenLoading} = useApiContract({...options, functionName: 'isPresaleOpen'});
  const {data:isPaused, runContractFunction:getIsPaused, isLoading:isPausedLoading} = useApiContract({...options, functionName: 'isPaused'});
  const {data, isFetching, runContractFunction} = useApiContract({...y5Options, functionName:"balanceOf", params:{account: user?.get("ethAddress") || account}})
  
  const { getBalances, data: userBalance, nativeToken } = useNativeBalance({ address: user?.get('ethAddress') });

  const [balance, setBalance] = useState(0);
  const [detail, setDetail] = useState({});

// console.log("userBalance",nativeToken);

    useLayoutEffect(() => {
      async function fetchDetails(){
        console.log('useEffect');
        // if(isAuthenticated){
       const myJob = new Promise(async (resolve, reject) => {
        if(isAuthenticated){
          console.log('isAuthenticated');
          await getBalances();
          await runContractFunction();
          resolve();
        }
       })
       .then(() => {
        console.log('then');
        setBalance(data);
       })
       .catch((err) => {
          console.log(err);
       })
       Promise.all([ 
        myJob,
        getTotalMint(),
         getMaxElements(),
         getMaxReserved(),
         getMaxPublic(),
         getMaxPrivate(),
         getSalePrice(),
         getPresalePrice(),
         getSaleStart(),
         getPresaleStart(),
         getIsPresaleOpen(),
         getIsPaused(),
        // getSalePriceByCount(),
        // getPresalePriceByCount()
      ])
         .then((values) => {
            console.log("values",values);
            
         })
         .catch((err) => console.log(err));
        
        setBalance(Moralis.Units.FromWei(userBalance.balance || 0, 'ether'));
      } 

      const timer = setTimeout(() => {
        console.log('the queue is now empty');
        console.log('data');
        fetchDetails();
      }, 2000);
      
      return () => {
        // cleanup
        clearTimeout(timer);
      }

    }, [isAuthenticated, saleStart]);

    console.log("context", [saleStart,presaleStart, userBalance, data])

    // if(!data) return null;
    return (
    <NFTContext.Provider value={{
      saleStart: Number(saleStart),
      presaleStart: Number(presaleStart),
      totalMint: Number(totalMint),
      maxPublic: Number(maxPublic),
      maxPrivate: Number(maxPrivate),
      maxElements: Number(maxElements),
      maxReserved: Number(maxReserved),
      salePrice: salePrice,
      presalePrice: presalePrice,
      salePriceETH: Number(Moralis.Units.FromWei(salePrice || 0, 'ether')),
      presalePriceETH: Number(Moralis.Units.FromWei(presalePrice || 0, 'ether')),
      // saleCP: Number(Moralis.Units.FromWei(saleCP || 0, 'ether')),
      // presaleCP: Number(Moralis.Units.FromWei(presaleCP || 0, 'ether')),
      isPresaleOpen: isPresaleOpen,
      isPaused: isPaused,
      userBalance: Number(Moralis.Units.FromWei(userBalance.balance || 0, 'ether')).toPrecision(4),
      // isWhitelisted,
      saleStartLoading, presaleStartLoading, 
      // saleCPLoading, presaleCPLoading,
      count,
      countHandle: setCount,
      }}>
        {children}
    </NFTContext.Provider>
  )
}

export default NFTContextProvider